module.exports = __webpack_public_path__ + "static/contact-7fbf89a83cf6a56096b44250ef45db7b.svg";